import { useEffect, useRef, useState } from "react";
import api from "@/lib/api";

const KIND = {
  fish: { color: "#38bdf8", label: "FISHING" },
  gamble: { color: "#FFB703", label: "COIN FLIP" },
  slots: { color: "#FF3366", label: "SLOTS" },
  payout: { color: "#22c55e", label: "COOKIE GIFT" },
  gift: { color: "#f472b6", label: "GIFT" },
  hug: { color: "#f472b6", label: "HUG" },
  shoutout: { color: "#a78bfa", label: "SHOUTOUT" },
  walkon: { color: "#22d3ee", label: "WALK-ON" },
  raid: { color: "#f59e0b", label: "RAID" },
  mood: { color: "#e879f9", label: "MOOD" },
};

export default function EventFeed({ className = "", onNew, onWheel, exclude = [] }) {
  const [events, setEvents] = useState([]);
  const after = useRef(new Date().toISOString());

  useEffect(() => {
    const poll = async () => {
      try {
        const r = await api.get(`/overlay/events?after=${encodeURIComponent(after.current)}`);
        if (r.data.length) {
          after.current = r.data[r.data.length - 1].created_at;
          const items = r.data.map((e) => ({ ...e, _k: e.id }));
          setEvents((prev) => [...prev, ...items].slice(-6));
          if (onNew) onNew(items);
          if (onWheel) {
            const w = items.find((i) => i.kind === "wheel");
            if (w) onWheel(Number(w.multiplier));
          }
          items.forEach((e) => setTimeout(() => setEvents((p) => p.filter((x) => x._k !== e._k)), 8000));
        }
      } catch (e) { /* ignore */ }
    };
    const t = setInterval(poll, 1500);
    poll();
    return () => clearInterval(t);
  }, []);

  return (
    <div className={`flex flex-col gap-3 ${className}`} data-testid="event-feed">
      {events.filter((e) => e.kind !== "wheel" && !exclude.includes(e.kind)).map((e) => {
        const k = KIND[e.kind] || { color: "#fff", label: e.kind?.toUpperCase() };
        return (
          <div
            key={e._k}
            className="animate-fade-up rounded-xl px-4 py-3 max-w-md backdrop-blur-md"
            style={{ background: "rgba(10,10,10,0.82)", border: `1px solid ${k.color}`, boxShadow: `0 0 24px ${k.color}55` }}
            data-testid="event-card"
          >
            <div className="text-[10px] font-800 tracking-widest mb-1" style={{ color: k.color, fontFamily: "Outfit, sans-serif" }}>{k.label}</div>
            <div className="text-white text-sm font-medium leading-snug">{e.text}</div>
          </div>
        );
      })}
    </div>
  );
}
